import { type ConfigType } from 'dayjs';
import type {
  ButtonHTMLAttributes,
  CSSProperties,
  DetailedHTMLProps,
  ReactNode,
} from 'react';

import { type HexColor } from '@/shared/types/common';

import { type AnyIcon } from '../icon';

export enum ButtonSize {
  xl64 = 'xl64',
  l50 = 'l50',
  s30 = 's30',
}

export enum ButtonVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  destructive = 'destructive',
  tertiary = 'tertiary',
  special = 'special',
}

type HtmlButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export interface ButtonTimerProps<T extends ConfigType = ConfigType> {
  className?: string;
  value: T;
  onEnd?: () => void;
}

export interface ButtonProps extends HtmlButtonProps {
  contentClassName?: string;
  icon?: AnyIcon;
  iconStyle?: CSSProperties;
  rightIcon?: AnyIcon;
  rightIconStyle?: CSSProperties;
  size?: ButtonSize;
  variant?: ButtonVariant;
  bubble?: boolean;

  counter?: ReactNode;

  shine?: boolean;
  media?: boolean;
  loading?: boolean;
  disabled?: boolean;

  timer?: ButtonTimerProps;
  color?: HexColor | undefined;
}
